import moment from "moment";

const getDiscountValid = (discounts) => {
  let totalPercent = 0;
  discounts?.map((value) => {
    if (
      moment() >= moment(value.startDate).add(7, "hours") &&
      moment() <= moment(value.endDate).add(7, "hours")
    ) {
      totalPercent += value.discountPercent;
    }
  });
  return totalPercent / 100;
};

export { getDiscountValid };
